module.exports = __webpack_public_path__ + "static/media/09.dce4ea7e.png";